/**
 * Step 1 - Job Details Component
 */

import React from 'react';
import Input from '../../../components/ui/Input';
import { EXPERIENCE_LEVELS, EMPLOYMENT_TYPES, REMOTE_OPTIONS } from '../constants';

export const Step1JobDetails = React.memo(({ jobData, errors, onUpdate }) => {
  const handleInputChange = (field, value) => {
    onUpdate({ [field]: value });
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-text-primary mb-4">
          Basic Job Information
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="md:col-span-2">
            <Input
              label="Job Title"
              value={jobData.title}
              onChange={(e) => handleInputChange('title', e.target.value)}
              placeholder="e.g., Virtual Assistant for E-commerce"
              error={errors.title}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Experience Level <span className="text-red-500">*</span>
            </label>
            <select
              value={jobData.experience_level}
              onChange={(e) => handleInputChange('experience_level', e.target.value)}
              className="w-full px-3 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
            >
              {EXPERIENCE_LEVELS.map(level => (
                <option key={level.value} value={level.value}>
                  {level.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Employment Type <span className="text-red-500">*</span>
            </label>
            <select
              value={jobData.employment_type}
              onChange={(e) => handleInputChange('employment_type', e.target.value)}
              className="w-full px-3 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
            >
              {EMPLOYMENT_TYPES.map(type => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <Input
              label="Location (Candidate Preferred Location)"
              value={jobData.location}
              onChange={(e) => handleInputChange('location', e.target.value)}
              placeholder="e.g., New York, NY or Worldwide"
              error={errors.location}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Work Arrangement <span className="text-red-500">*</span>
            </label>
            <select
              value={jobData.remote_work}
              onChange={(e) => handleInputChange('remote_work', e.target.value)}
              className="w-full px-3 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
            >
              {REMOTE_OPTIONS.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="mt-6">
          <label className="block text-sm font-medium text-text-primary mb-2">
            Job Description <span className="text-red-500">*</span>
          </label>
          <textarea
            value={jobData.description}
            onChange={(e) => handleInputChange('description', e.target.value)}
            placeholder="Describe the role, company culture, and what makes this opportunity unique..."
            rows={6}
            className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary ${
              errors.description ? 'border-red-500' : 'border-border'
            }`}
          />
          {errors.description && (
            <p className="mt-1 text-sm text-red-600">{errors.description}</p>
          )}
        </div>
      </div>
    </div>
  );
});

Step1JobDetails.displayName = 'Step1JobDetails';
